import React, { useState, useCallback, memo } from "react"
import Dialog from "@material-ui/core/Dialog"
import MuiDialogTitle from "@material-ui/core/DialogTitle"
import MuiDialogContent from "@material-ui/core/DialogContent"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"
import { withStyles, makeStyles } from "@material-ui/core/styles"
import Box from "@material-ui/core/Box"
import Typography from "@material-ui/core/Typography"
import Button from "@material-ui/core/Button"
import { sendRoleSettingReminderEmail } from "@/apis"
import RequestSnackbar from "@/components/common/RequestSnackbar"
import useHandleRequestSnackbar from "@/hooks/useHandleRequestSnackbar"

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(5),
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: "#ffffff",
        backgroundColor: theme.palette.primary.main,
        width: "28px",
        height: "28px",
        "&:hover": {
            backgroundColor: theme.palette.primary.secondary,
        },
    },
})

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose} size="small">
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    )
})

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(0),
    },
}))(MuiDialogContent)

const useStyles = makeStyles((theme) => ({
    dialogContent: {
        zIndex: "1",
    },
    contentWrapper: {
        padding: theme.spacing(0, 3),
        paddingBottom: theme.spacing(3),
        margin: "0 auto",
        maxWidth: "650px",
        textAlign: "center",
        "&>p": {
            marginBottom: theme.spacing(2),
        },
    },
    contentTitle: {
        marginBottom: theme.spacing(4),
    },
}))

const ModalReminderSetRole = memo((props) => {
    const { modalRoleRemindShow, handleClose, targetParticipant } = props
    const classes = useStyles()
    const handleCancel = () => {
        handleClose()
    }

    const [request, setRequest] = useState({
        successStatus: true,
        message: "",
        messagePopup: false,
    })
    const requestSnackbarValue = useHandleRequestSnackbar(request.messagePopup)

    const sendRoleSettingReminderEmailFunc = async (participantId, projectId) => {
        try {
            await sendRoleSettingReminderEmail({ participantId, projectId })
            setRequest({
                successStatus: true,
                message: "reminder is sent",
                messagePopup: true,
            })
        } catch (e) {
            setRequest({
                successStatus: false,
                message: "reminder sent has error",
                messagePopup: true,
            })
        } finally {
            setRequest((prev) => ({ ...prev, messagePopup: false }))
        }
    }

    const handleConfirm = useCallback(() => {
        const { participantId, projectId } = targetParticipant
        sendRoleSettingReminderEmailFunc(participantId, projectId)
        handleClose()
    }, [targetParticipant])

    return (
        <>
            {targetParticipant ? (
                <>
                    <Dialog disableScrollLock aria-labelledby="reminder-set-up-role" open={modalRoleRemindShow} maxWidth="md" fullWidth>
                        <DialogTitle className={classes.closeButton} id="reminder-set-up-role" onClose={handleClose} />
                        <DialogContent className={classes.dialogContent}>
                            <Box className={classes.contentWrapper}>
                                <Typography variant="h6" component="h2" className={classes.contentTitle} color="textPrimary">
                                    Send a reminder to participant?
                                </Typography>
                                <Typography component="p">
                                    Are you sure you want to send a reminder for the role selection and start of assessment to&nbsp;
                                    {targetParticipant.firstName}&nbsp;
                                    {targetParticipant.lastName}?
                                </Typography>
                                <Typography component="p">Click sent to confirm.</Typography>
                                <Box className={classes.buttonWrapper} m={4} display="flex" justifyContent="center" alignItems="center">
                                    <Button variant="outlined" color="primary" onClick={handleCancel}>
                                        Cancel
                                    </Button>
                                    <Box>&nbsp;&nbsp;</Box>
                                    <Button variant="contained" color="primary" onClick={handleConfirm}>
                                        send
                                    </Button>
                                </Box>
                            </Box>
                        </DialogContent>
                    </Dialog>
                    <RequestSnackbar
                        status={request.successStatus}
                        message={request.message}
                        snackbarOpen={requestSnackbarValue.snackbarOpen}
                        handleSnackbarOpenStatus={requestSnackbarValue.handleSnackbarOpenStatus}
                    />
                </>
            ) : null}
        </>
    )
})

export default ModalReminderSetRole
